import { createContext } from 'react';

import { AlertContextDispatch } from './AlertContextController.types';

export const AlertDispatchContext = createContext<AlertContextDispatch | undefined>(undefined);
